<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>

<template>
  <div class="card">    
    <div
      class="card-header d-flex align-items-center bg-primary font-weight-bold text-white"      
    >
      Test Center
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    
    <div class="card-body">
      <form @submit.prevent="postData">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="name" class="font-weight-bold">Nama Test Center</label>
            <input
              type="text"
              class="form-control"
              id="namaTcInput"
              placeholder="Masukkan Nama Test Center"
              v-model="formData.namaTc"
              :class="{
                'is-invalid': $v.formData.namaTc.$error                
              }"
            />            
          </div>          
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="email" class="font-weight-bold">Email</label>
            <input
              type="email"
              class="form-control"
              id="emailInput"
              placeholder="Masukkan Email Test Center"
              v-model="formData.email"
              :class="{
                'is-invalid': $v.formData.email.$error
              }"
            />            
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="alamat" class="font-weight-bold">Alamat</label>
            <textarea
              class="form-control"
              id="alamatInput"
              placeholder="Masukkan Alamat Test Center"
              v-model="formData.alamat"
              :class="{
                'is-invalid': $v.formData.alamat.$error
              }"
            ></textarea>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="telp_op" class="font-weight-bold">Telepon Operator</label>
            <input
              type="number"
              class="form-control"
              id="telpOperatorInput"
              placeholder="Masukkan Nomor Telepon Operator"
              v-model="formData.telpOperator"
              :class="{
                'is-invalid': $v.formData.telpOperator.$error,                   
              }"
            />         
          </div>          
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="telp_tc" class="font-weight-bold">Telepon Test Center</label>
            <input
              type="number"
              class="form-control"
              id="telpTcInput"
              placeholder="Masukkan Nomor Telepon Test Center"
              v-model="formData.telpTc"
              :class="{
                'is-invalid': $v.formData.telpTc.$error,                   
              }"
            />           
          </div>
        </div>  
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="prov" class="font-weight-bold">Provinsi</label>            
            <multiselect
                id="provinsiSelect"
                label="name"                
                placeholder="Pilih Provinsi"
                @input="pilihProvinsi"
                v-model="multi_provinsi"
                :options="optionProvinsi"
                :class="{
                  'has-error': $v.multi_provinsi.$error
                }"
            ></multiselect>            
          </div>                    
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="prov" class="font-weight-bold">Kota/Kabupaten</label>
            <multiselect
                label="name"                
                id="kotaKabSelect"
                placeholder="Pilih Kota / Kabupaten"
                @input="pilihKotaKab"
                v-model="multi_kota_kab"
                :options="optionKotaKabSelect"
                :class="{
                  'has-error': $v.multi_kota_kab.$error
                }"
              ></multiselect>              
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div id="mapTestCenter" style="height:400px;z-index:0"></div>
            <small><i class="color-grey">*Harap Klik/Pin titik lokasi Test Center</i></small>
            <br>
            <br>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="email" class="font-weight-bold">Latitude</label>
                <input
                  type="text"
                  class="form-control"
                  id="latitude"
                  placeholder="°"
                  v-model="formData.latitude"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="alamat" class="font-weight-bold">Longitude</label>
                <input
                  type="text"
                  class="form-control"
                  id="longtitude"
                  placeholder="°"
                  v-model="formData.longitude"
                />
              </div>
            </div>
          </div>          
        </div>              
        <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 float-right">          
          <Button
            class="btn btn-md btn-success px-4 py-2"
            type="submit"
          >
            Simpan
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import { required, email } from "vuelidate/lib/validators";

import DataTestCenterServices from "@/services/datamaster/data-test-center.service";
import { Location } from "@/mixins/lokasi/Location";

import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import * as esri_geo from 'esri-leaflet-geocoder'

import mapMarker from '@/assets/icons/map-marker-alt-solid.svg';

export default {
  name: "Data Test Center",
  mixins : [Location],
  data() {
    return {
      actionPost: "",
      optionKotaKabSelect : [],
      formData: {
        kodeTc: "",
        namaTc: "",
        email: "",
        alamat: "",
        kota: "",
        kabupaten: "",

        provinsi: "",
        telpOperator: "",
        telpTc: "",
        operator: "",
        status: "",
        idTc: "",
        latitude: 0,
        longitude: 0
      }
    };
  },
  mounted() {
    this.getKoordinat();
    this.getAllProvinsi();
    this.getAllKotaKab();
  },
  validations: {
    formData: {
      namaTc: { required },
      email: { required, email },
      alamat: { required },            
      telpOperator: { required },
      telpTc: { required }, 
    },
    multi_provinsi: { required },
    multi_kota_kab: { required },
  },

  watch: {
    'formData.namaTc': function() {
      this.$v.formData.namaTc.$touch();
      if(!this.$v.formData.namaTc.$error) {
        document.getElementById("namaTcInput").classList.add("is-valid")
      }
    },
    'formData.email': function() {
      this.$v.formData.email.$touch();
      if(!this.$v.formData.email.$error) {
        document.getElementById("emailInput").classList.add("is-valid")
      }
    },
    'formData.alamat': function() {
      this.$v.formData.alamat.$touch();
      if(!this.$v.formData.alamat.$error) {
        document.getElementById("alamatInput").classList.add("is-valid")
      }
    },
    'formData.telpOperator': function() {
      this.$v.formData.telpOperator.$touch();
      if(!this.$v.formData.telpOperator.$error) {
        document.getElementById("telpOperatorInput").classList.add("is-valid")
      }
    },
    'formData.telpTc': function() {
      this.$v.formData.telpTc.$touch();
      if(!this.$v.formData.telpTc.$error) {
        document.getElementById("telpTcInput").classList.add("is-valid")
      }
    },
    'multi_provinsi': function() {
      this.multi_kota_kab = [];
    }
  },

  methods: {                    
    pilihKotaKab(val) {
      this.formData.kota = val.id_kota_kab;
      this.$v.multi_kota_kab.$touch();      
    },

    pilihProvinsi(val) {
      var kotakab = this.optionKotaKab.filter(el => el.id_provinsi === val.idProvinsi);      
      this.optionKotaKabSelect = kotakab;
      this.multi_kota_kab = [];
      this.formData.provinsi = val.idProvinsi
      this.$v.multi_provinsi.$touch();            
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    getKoordinat() {
      var vm = this;
      var map = L.map("mapTestCenter").setView(
        [-2.811371193331128, 121.55479501146787],
        4
      );
      // var map = L.map("mapTestCenter").setView(
      //   [40.91, -96.63], 4
      // );

      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      if (vm.marker != undefined) {
        map.removeLayer(vm.marker);
      }

      //nambah marker ketika klik
      var customMarker = L.icon({
        iconUrl: '/img/map-marker-alt-solid.svg',
        iconSize: [20, 40],
        iconAnchor: [14, 43.705878]
      });        

      var arcgisOnline = esri_geo.arcgisOnlineProvider();
      var searchControl = esri_geo.geosearch({
          providers: [arcgisOnline]
      }).addTo(map);
      var results = L.layerGroup().addTo(map);

      searchControl.on('results', function(data){
        results.clearLayers();
        for (var i = data.results.length - 1; i >= 0; i--) {
          results.addLayer(L.marker(data.results[i].latlng));
          vm.marker = L.marker((data.results[i].latlng), { icon: customMarker }).addTo(map);
          vm.formData.latitude = data.results[i].latlng.lat;
          vm.formData.longitude = data.results[i].latlng.lng;
        }
      });     
      
      map.on("click", function(e) {
        var lat = e.latlng.lat;
        var lon = e.latlng.lng;


        //hapus marker eksisting
        if (vm.marker != undefined) {
          map.removeLayer(vm.marker);
        }

        //nambah marker ketika klik
        var customMarker = L.icon({
          iconUrl: mapMarker,
          iconSize: [20, 40],
          iconAnchor: [14, 43.705878]
        });        

        vm.marker = L.marker([lat, lon], { icon: customMarker }).addTo(map);

        let setLong = document.getElementById("longtitude");
        setLong.value = lon;
        setLong.dispatchEvent(new Event("input"));

        let setLat = document.getElementById("latitude");
        setLat.value = lat;
        setLat.dispatchEvent(new Event("input"));
      });
    },
    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
    },

    postData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.insertData(this.formData);
      }            
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("posat");
      DataTestCenterServices.postDataTestCenter(formData)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          this.$v.$reset();
          // this.myModal = false;
          this.alertSuccess();
          this.$router.push({ path : "/data-master/data-test-center" });
          // this.getData("1");
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      DataTestCenterServices.putDataTestCenter(this.formData)
        .then(response => {
          this.myModal = false;

          this.alertSuccess();

          this.getData("1");
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>
